import { EmailOutlined, LinkedIn, Twitter } from "@mui/icons-material";
import { Instagram } from "iconsax-react"

export const FOOTER_LINKS = [
  {
    title: "Timeline",
    path: "/#roadmap",
  },
  {
    title: "Contact",
    path: "/contact",
  },
  {
    title: "FAQ",
    path: "/#FAQ",
  },
  {
    title: "Team",
    path: "/team",
  },
];

export const SOCIAL_LINKS = [
  {
    platform: "linkedIn",
    icon: <LinkedIn />,
    url: "https://www.linkedin.com/company/flexibus-in/",
  },
  {
    platform: "instagram",
    icon: <Instagram />,
    url: "https://instagram.com/flexibus.in",
  },
  {
    platform: "Twitter",
    icon: <Twitter />,
    url: "https://twitter.com",
  },
  {
    platform: "Email",
    icon: <EmailOutlined />,
    url: "mailto:flexibus.in@gmail.com",
  },
];
